import CustomerService from "@/services/api/customer";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const name = "user";

const initialState = {
  customer: [],
  totalCustomer: 0,
  isFetching: false,
};

export const getCustomer = createAsyncThunk(
  `${name}/getCustomer`,
  async (params, { rejectWithValue }) => {
    try {
      const data = await CustomerService.getCustomer(params);
      return data.data || [];
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    clear: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCustomer.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(getCustomer.fulfilled, (state, action) => {
        state.isFetching = false;
        state.customer = action.payload.rows;
        state.totalCustomer = action.payload.count;
      })
      .addCase(getCustomer.rejected, (state, action) => {
        state.isFetching = false;
        console.error("Failed to fetch customer:", action.payload);
      });
  },
});

export default customerSlice.reducer;
export const { clear } = customerSlice.actions;
